<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="主页" name="first"></el-tab-pane>
            <el-tab-pane label="统计" name="second"></el-tab-pane>
            <el-tab-pane label="动态" name="third"></el-tab-pane>
        </el-tabs>
        <Index v-if="activeName == 'first'"></Index>
        <Stat v-if="activeName == 'second'"></Stat>
        <Dynamic v-if="activeName == 'third'"></Dynamic>
    </div>
</template>

<script>
import Index from "./Index.vue";
import Stat from "./Stat.vue";
import Dynamic from "./Dynamic.vue";
export default {
    components: {
        Index,
        Stat,
        Dynamic,
    },
    data() {
        return {
            activeName: 'first'
        };
    },
    methods: {

    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__item{
    height: 32px;
    line-height: 32px;
}
</style>